var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("dataScreening", {
            attrs: {
              propsData: {
                isCurrency: false,
                isPayChannel: false,
                adChannel: false,
                adPlacement: false,
                isCountry: false,
                isDate: false
              }
            },
            on: {
              searchChange: _vm.searchChange,
              currencyChange: _vm.currencyChange
            }
          }),
          _vm.rawData.game_mark.indexOf("yjfm") == -1
            ? [
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "flex-1",
                        attrs: { filterable: "", placeholder: "请选择" },
                        on: { change: _vm.getServer },
                        model: {
                          value: _vm.paramsData.is_prod,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "is_prod", $$v)
                          },
                          expression: "paramsData.is_prod"
                        }
                      },
                      _vm._l(_vm.severlist, function(item) {
                        return _c("el-option", {
                          key: item.label,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "flex-1",
                        attrs: {
                          clearable: "",
                          filterable: "",
                          placeholder: "请选择服务器"
                        },
                        on: { change: _vm.YjfmSeverChange },
                        model: {
                          value: _vm.paramsData.server_id,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "server_id", $$v)
                          },
                          expression: "paramsData.server_id"
                        }
                      },
                      _vm._l(_vm.serverList, function(item) {
                        return _c("el-option", {
                          key: item.serverID,
                          attrs: {
                            label: item.serverName,
                            value: item.serverID
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ]
            : [
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "flex-1",
                        attrs: { filterable: "", placeholder: "请选择" },
                        on: { change: _vm.envIdChange },
                        model: {
                          value: _vm.paramsData.env_id,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "env_id", $$v)
                          },
                          expression: "paramsData.env_id"
                        }
                      },
                      _vm._l(_vm.szgmEnv, function(item) {
                        return _c("el-option", {
                          key: item.label,
                          attrs: { label: item.label, value: item.id }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { filterable: "", placeholder: "服务器渠道" },
                        on: { change: _vm.serverChange },
                        model: {
                          value: _vm.server_channel,
                          callback: function($$v) {
                            _vm.server_channel = $$v
                          },
                          expression: "server_channel"
                        }
                      },
                      _vm._l(_vm.serverChannel, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          clearable: "",
                          filterable: "",
                          placeholder: "是否展示测试服"
                        },
                        on: { change: _vm.serverChannelChange },
                        model: {
                          value: _vm.show_test,
                          callback: function($$v) {
                            _vm.show_test = $$v
                          },
                          expression: "show_test"
                        }
                      },
                      _vm._l(_vm.serverType, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          filterable: "",
                          clearable: "",
                          placeholder: "服务器"
                        },
                        on: { change: _vm.severChange },
                        model: {
                          value: _vm.paramsData.server_id,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "server_id", $$v)
                          },
                          expression: "paramsData.server_id"
                        }
                      },
                      _vm._l(_vm.serverListYJ, function(item) {
                        return _c("el-option", {
                          key: item.serverID,
                          attrs: {
                            label: item.serverName,
                            value: item.serverID
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ],
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  directives: [
                    {
                      name: "select-scroll",
                      rawName: "v-select-scroll",
                      value: _vm.loadMoreDocTypes,
                      expression: "loadMoreDocTypes"
                    }
                  ],
                  attrs: {
                    multiple: "",
                    "collapse-tags": "",
                    clearable: "",
                    filterable: "",
                    placeholder: "文档类型"
                  },
                  model: {
                    value: _vm.searchData.doc_types,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "doc_types", $$v)
                    },
                    expression: "searchData.doc_types"
                  }
                },
                [
                  _vm._l(_vm.documentTypeList, function(item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value }
                    })
                  }),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "text-align": "center",
                        padding: "10px",
                        "font-size": "12px",
                        color: "#999"
                      }
                    },
                    [
                      _vm.docTypeLoading
                        ? _c("span", [
                            _c("i", { staticClass: "el-icon-loading" }),
                            _vm._v(" 加载中...")
                          ])
                        : !_vm.docTypeHasMore && _vm.documentTypeList.length > 0
                        ? _c("span", [_vm._v("没有更多文档类型了")])
                        : _vm._e()
                    ]
                  )
                ],
                2
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "问题文本" },
                model: {
                  value: _vm.searchData.query,
                  callback: function($$v) {
                    _vm.$set(_vm.searchData, "query", $$v)
                  },
                  expression: "searchData.query"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "最大返回条数" },
                model: {
                  value: _vm.searchData.top_k,
                  callback: function($$v) {
                    _vm.$set(_vm.searchData, "top_k", $$v)
                  },
                  expression: "searchData.top_k"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "最低相关性阈值" },
                model: {
                  value: _vm.searchData.score_threshold,
                  callback: function($$v) {
                    _vm.$set(_vm.searchData, "score_threshold", $$v)
                  },
                  expression: "searchData.score_threshold"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.searchClick(1)
                    }
                  }
                },
                [_vm._v("搜索")]
              )
            ],
            1
          )
        ],
        2
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "sticky-table-header",
              rawName: "v-sticky-table-header",
              value: 0,
              expression: "0"
            },
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.reqLoading,
              expression: "reqLoading"
            }
          ],
          ref: "tableRef",
          staticStyle: { width: "100%" },
          attrs: { id: "tableRef", data: _vm.tableData, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "doc_id", label: "命中文档 ID" }
          }),
          _c("el-table-column", {
            attrs: { prop: "version", label: "命中文档版本" }
          }),
          _c("el-table-column", {
            attrs: { prop: "doc_type", label: "doc_type" }
          }),
          _c("el-table-column", {
            attrs: { prop: "chunk_id", label: "命中切片 ID" }
          }),
          _c("el-table-column", {
            attrs: { prop: "tenant_id", label: "命中资料租户" }
          }),
          _c("el-table-column", {
            attrs: { prop: "game", label: "命中资料游戏" }
          }),
          _c("el-table-column", {
            attrs: { prop: "server_id", label: "命中资料区服ID" }
          }),
          _c("el-table-column", {
            attrs: { prop: "server_name", label: "命中资料区服名称" }
          }),
          _c("el-table-column", {
            attrs: { prop: "env", label: "命中资料环境" }
          }),
          _c("el-table-column", {
            attrs: { prop: "source_id", label: "命中资料来源 ID" }
          }),
          _c("el-table-column", {
            attrs: { prop: "title", label: "命中文档标题" }
          }),
          _c("el-table-column", {
            attrs: { prop: "score", label: "相关性分数" }
          }),
          _c("el-table-column", {
            attrs: { prop: "content_preview", label: "命中内容预览" }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "custom-pagination" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", disabled: _vm.searchData.page === 1 },
              on: {
                click: function($event) {
                  return _vm.changePage(_vm.searchData.page - 1)
                }
              }
            },
            [_vm._v(" 上一页 ")]
          ),
          _c("span", { staticClass: "page-num" }, [
            _vm._v("第 " + _vm._s(_vm.searchData.page) + " 页")
          ]),
          _c(
            "el-button",
            {
              attrs: { size: "small", disabled: !_vm.hasMore },
              on: {
                click: function($event) {
                  return _vm.changePage(_vm.searchData.page + 1)
                }
              }
            },
            [_vm._v(" 下一页 ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }